(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-nutra-variant-filter]');
    if (!section) return;

    var packGrid   = section.querySelector('[data-pack-grid]');
    var flavorGrid = section.querySelector('[data-flavor-grid]');
    if (!packGrid || !flavorGrid) return;

    function filterFlavors() {
      // Find the currently selected pack button
      var selectedPack = packGrid.querySelector('[data-pack].is-selected');
      if (!selectedPack) selectedPack = packGrid.querySelector('[data-pack]');
      if (!selectedPack) return;

      var packValue   = (selectedPack.getAttribute('data-pack-value') || '').toLowerCase();
      var is2Week    = packValue.indexOf('2 week') !== -1 && packValue.indexOf('starter') !== -1;
      var isSachet   = packValue.indexOf('sachet') !== -1;
      var is4Week    = packValue.indexOf('4 week') !== -1;
      var is8Week    = packValue.indexOf('8 week') !== -1;

      var flavorBtns     = flavorGrid.querySelectorAll('[data-flavor]');
      var selectedHidden = false;
      var firstVisible   = null;

      flavorBtns.forEach(function (btn) {
        var val = (btn.getAttribute('data-flavor-value') || '').trim().toLowerCase();
        var allowed;

        if (is2Week) {
          // 2 Week Starter: only chocolate and vanilla
          allowed = val === 'chocolate' || val === 'vanilla';
        } else if (isSachet) {
          // 30 Sachet Travel Pack: show only Chocolate, Vanilla, 5 Chocolate & 5 Vanilla
          allowed = val.indexOf('1 chocolate') === -1 && val.indexOf('2 chocolate') === -1;
        } else if (is4Week) {
          // 4 Week Routine: hide "5 chocolate & 5 vanilla" and "2 chocolate & 1 vanilla pouch"
          allowed = val.indexOf('5 chocolate') === -1 && val.indexOf('2 chocolate') === -1;
        } else if (is8Week) {
          // 8 Week Convenience: hide "1 chocolate & 5 vanilla", "1 chocolate & 1 vanilla pouch", "5 chocolate & 5 vanilla"
          allowed = val.indexOf('1 chocolate') === -1 && val.indexOf('5 chocolate') === -1;
        } else {
          allowed = true;
        }

        btn.style.display = allowed ? '' : 'none';

        if (allowed && !firstVisible) firstVisible = btn;

        if (!allowed && btn.classList.contains('is-selected')) {
          selectedHidden = true;
        }
      });

      // If the active flavour is now hidden, click the first visible one
      if (selectedHidden && firstVisible) {
        firstVisible.click();
      }
    }

    // Run on every pack click
    packGrid.addEventListener('click', function (e) {
      var packBtn = e.target.closest('[data-pack]');
      if (!packBtn) return;
      // Small delay so is-selected class updates first
      setTimeout(filterFlavors, 10);
    });

    // Watch for programmatic pack selection (URL params, etc.)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class') filterFlavors();
      });
    });
    packGrid.querySelectorAll('[data-pack]').forEach(function (btn) {
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });

    // Run on page load
    filterFlavors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
